/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PaymentLogDto
 */
export interface PaymentLogDto {
    /**
     *
     * @type {number}
     * @memberof PaymentLogDto
     */
    paymentLogId?: number;
    /**
     *
     * @type {Date}
     * @memberof PaymentLogDto
     */
    createdAt?: Date;
    /**
     *
     * @type {string}
     * @memberof PaymentLogDto
     */
    provider?: PaymentLogDtoProviderEnum;
    /**
     *
     * @type {string}
     * @memberof PaymentLogDto
     */
    providerUserId?: string;
    /**
     *
     * @type {string}
     * @memberof PaymentLogDto
     */
    operation?: PaymentLogDtoOperationEnum;
    /**
     *
     * @type {string}
     * @memberof PaymentLogDto
     */
    currencyCode?: string;
    /**
     *
     * @type {number}
     * @memberof PaymentLogDto
     */
    amount?: number;
    /**
     *
     * @type {number}
     * @memberof PaymentLogDto
     */
    userBillingAccountId?: number;
    /**
     *
     * @type {string}
     * @memberof PaymentLogDto
     */
    ledgerId?: string;
    /**
     *
     * @type {string}
     * @memberof PaymentLogDto
     */
    deviceIdentity?: string;
    /**
     *
     * @type {number}
     * @memberof PaymentLogDto
     */
    transactionId?: number;
    /**
     *
     * @type {string}
     * @memberof PaymentLogDto
     */
    description?: string;
    /**
     *
     * @type {string}
     * @memberof PaymentLogDto
     */
    providerOperation?: string;
    /**
     *
     * @type {string}
     * @memberof PaymentLogDto
     */
    providerRef?: string;
    /**
     *
     * @type {number}
     * @memberof PaymentLogDto
     */
    errorNo?: number;
    /**
     *
     * @type {string}
     * @memberof PaymentLogDto
     */
    logDetails?: string;
}

/**
 * @export
 */
export const PaymentLogDtoProviderEnum = {
    Unknown: "Unknown",
    StripeSandbox: "StripeSandbox",
    Stripe: "Stripe",
} as const;
export type PaymentLogDtoProviderEnum =
    (typeof PaymentLogDtoProviderEnum)[keyof typeof PaymentLogDtoProviderEnum];

/**
 * @export
 */
export const PaymentLogDtoOperationEnum = {
    Unknown: "Unknown",
    Subscription: "Subscription",
    StripeInvoice: "StripeInvoice",
    StripeMeterEvent: "StripeMeterEvent",
} as const;
export type PaymentLogDtoOperationEnum =
    (typeof PaymentLogDtoOperationEnum)[keyof typeof PaymentLogDtoOperationEnum];

/**
 * Check if a given object implements the PaymentLogDto interface.
 */
export function instanceOfPaymentLogDto(value: object): value is PaymentLogDto {
    return true;
}

export function PaymentLogDtoFromJSON(json: any): PaymentLogDto {
    return PaymentLogDtoFromJSONTyped(json, false);
}

export function PaymentLogDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): PaymentLogDto {
    if (json == null) {
        return json;
    }
    return {
        paymentLogId:
            json["paymentLogId"] == null ? undefined : json["paymentLogId"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        provider: json["provider"] == null ? undefined : json["provider"],
        providerUserId:
            json["providerUserId"] == null ? undefined : json["providerUserId"],
        operation: json["operation"] == null ? undefined : json["operation"],
        currencyCode:
            json["currencyCode"] == null ? undefined : json["currencyCode"],
        amount: json["amount"] == null ? undefined : json["amount"],
        userBillingAccountId:
            json["userBillingAccountId"] == null
                ? undefined
                : json["userBillingAccountId"],
        ledgerId: json["ledgerId"] == null ? undefined : json["ledgerId"],
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        transactionId:
            json["transactionId"] == null ? undefined : json["transactionId"],
        description:
            json["description"] == null ? undefined : json["description"],
        providerOperation:
            json["providerOperation"] == null
                ? undefined
                : json["providerOperation"],
        providerRef:
            json["providerRef"] == null ? undefined : json["providerRef"],
        errorNo: json["errorNo"] == null ? undefined : json["errorNo"],
        logDetails: json["logDetails"] == null ? undefined : json["logDetails"],
    };
}

export function PaymentLogDtoToJSON(value?: PaymentLogDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        paymentLogId: value["paymentLogId"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        provider: value["provider"],
        providerUserId: value["providerUserId"],
        operation: value["operation"],
        currencyCode: value["currencyCode"],
        amount: value["amount"],
        userBillingAccountId: value["userBillingAccountId"],
        ledgerId: value["ledgerId"],
        deviceIdentity: value["deviceIdentity"],
        transactionId: value["transactionId"],
        description: value["description"],
        providerOperation: value["providerOperation"],
        providerRef: value["providerRef"],
        errorNo: value["errorNo"],
        logDetails: value["logDetails"],
    };
}
